import "./WebApp.css";
import SmallCircle from "../../reuseable/SmallCircle/SmallCircle";
import ProductivityApp from "../../pages/WebAppProject/WebAppProject";
import Copyright from "../../reuseable/Copyright/Copyright";

function WebApp() {
  return (
    <div className="product container">
      <div className="product__top">
        <SmallCircle />
        <h1 className="product__title">Explore My Web Apps</h1>
      </div>

      {/* done one */}

      <div className="product__title-subtitle">
        <h4 className="product__subtitle">
          Front End / Back End / MERN Projects 🚀
        </h4>
        <small className="product__description">
          I build Creative ui and smooth Web based app and different kinds of
          SAAS products.🌱
        </small>
      </div>

      {/* Project Section start  */}

      <div className="productivity__web_app">
        <ProductivityApp />
      </div>

      {/* Project Section End  */}

      <Copyright />
    </div>
  );
}

export default WebApp;
